import { useCallback } from "react";
import { useWorkOrderStore } from "../../store/wo-order";
import { getCustomColumnsWithGroup } from "../../api/WorkOrders";

export default function useGetCustomColumns() {
  const setCustomFields = useWorkOrderStore((state) => state.setCustomFields);

  const getCustomColumns = useCallback(async (
    subCategory?: string,
    updateStore = true,
    useOnEntry = false
  ) => {
    const response = await getCustomColumnsWithGroup(undefined, subCategory, useOnEntry);
    if (!response.isError) {
      const customFields = Object.keys(response.data.fields).map((key) => {
        const fieldValue = response.data.fields[key];
        const [category, subcategory, element] = key.split("|");

        return {
          ...fieldValue,
          Category: category,
          Subcategory: subcategory || " ",
          Element: element || fieldValue.IdText,
          filteredValues: fieldValue.ValidValues,
        };
      });

      if (updateStore) setCustomFields(customFields);
      return customFields;
    }
    return null;
  }, [setCustomFields]);

  return { getCustomColumns };
}
